import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import retardUpdate from '../../../lib/react/update-retarder';
import {CustomScrollbarTrackVisibility} from '../../../lib/custom-scrollbar/custom-scrollbar-model';
import {OENoteFlags, OENoteViewerEditFlags, OENoteStateBits} from './oe-note-model';
import OENotePopover from './oe-note-popover';
import OENoteTextEdit from './elements/oe-note-text-edit';

export default class OENoteViewerEditPopover extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = null;
        this.isOpen = false;
        this.rect = null;

        this.shortCutsDisabled = false;
        this.needsSave = false;
        
        this.state = {
            id: this.id,
            isOpen: this.isOpen,
            singleLine: false,
            maxTextLength: 0
        };

        //this.onNoteLongTouched = this.onNoteLongTouched.bind(this);
        this.onNoteClicked = this.onNoteClicked.bind(this);
        this.onNotesEnabledChanged = this.onNotesEnabledChanged.bind(this);
        this.onNotesEditModeChanged = this.onNotesEditModeChanged.bind(this);
        this.onNoteFlagsChanged = this.onNoteFlagsChanged.bind(this);
        this.onNoteViewerEditParamsChanged = this.onNoteViewerEditParamsChanged.bind(this);
        this.onNoteRemoved = this.onNoteRemoved.bind(this);
        this.onPresentationAnimationModeChanged = this.onPresentationAnimationModeChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onToggle = this.onToggle.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    componentDidMount() {
        this.mounted = true;
        this.updateShortCutsDisabled();
    }

    componentWillUnmount()    {
        this.mounted = false;
        if(this.isOpen)    this.saveIfNeeded();
        this.needsSave = false;
        this.updateShortCutsDisabled();
    }

    onConnect()  {
        //this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteLongTouched, this.onNoteLongTouched);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteClicked, this.onNoteClicked);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.notesEnabledChanged, this.onNotesEnabledChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.notesEditModeChanged, this.onNotesEditModeChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteFlagsChanged, this.onNoteFlagsChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteViewerEditParamsChanged, this.onNoteViewerEditParamsChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteRemoved, this.onNoteRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationAnimationModeChanged, this.onPresentationAnimationModeChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        //this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteLongTouched, this.onNoteLongTouched);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteClicked, this.onNoteClicked);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.notesEnabledChanged, this.onNotesEnabledChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.notesEditModeChanged, this.onNotesEditModeChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteFlagsChanged, this.onNoteFlagsChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteViewerEditParamsChanged, this.onNoteViewerEditParamsChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteRemoved, this.onNoteRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationAnimationModeChanged, this.onPresentationAnimationModeChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onOpenStateChanged()	{
        if(!this.oe.isReady()) return;
        
        //
        if(!this.isOpen)    this.saveIfNeeded();
        this.needsSave = false;

        //
        let controller = this.oe.sharedInterface.getUIControllerModelState();
        controller.setUpdateEnabled(!this.isOpen);

        //
        let pres = this.oe.sharedInterface.getUIControllerPresentation();
        if(pres.getAnimationMode() == this.oe.Module.AnimationMode.play)  {
            pres.setAnimationMode(this.oe.Module.AnimationMode.pause);
        }

        //
        this.updateShortCutsDisabled();

        //
        let userInfo = new this.oe.Module.Dictionary();
        this.oe.sharedInterface.postNotification(this.oe.NotificationName.uiInstanceNoteViewerEditPopoverOpenStateChanged, userInfo.setBoolValue('open', this.isOpen));
        userInfo.delete();
    }

    setOpen(isOpen = true) {
        if(this.isOpen == isOpen || (isOpen && !this.canOpen())) return;
        this.isOpen = isOpen;
        this.setState({isOpen: isOpen});
        this.onOpenStateChanged();
    }

    close()	{
        this.setOpen(false);
    }

    open(rect)	{
        this.setOpen(true);
    }

    canOpen(id)	{
        id = id || this.id;
        if(id === null || !this.oe.isReady()) return false;

        let controller = this.oe.sharedInterface.getUIControllerNote();

        if(!controller.getEnabled() || (controller.getUIEnabled() && controller.isEditingEnabled()))    return false;

        let flags = controller.getNoteFlags(id);
        if(!(flags & OENoteFlags.textViewerEditable))   return false;

        return true;
    }

    setId(id) {
        if(typeof(id) !== 'number') id = null;
        if(this.id === id)  return;
        let prevId = this.id;
        this.id = id;
        this.setState({id: id});
        this.onIDChanged(prevId);
    }

    onIDChanged(prevId)   {
        //
        if(this.isOpen)    this.saveIfNeeded(prevId);
        this.needsSave = false;

        //
        retardUpdate(this, () => {
            this.updateIsOpenState();
            this.updateSingleLineState();
            this.updateMaxTextLengthState();
        });
    }

    setShortCutsDisabled(disable)   {
        if(!this.oe.isReady())  return;
        if(this.shortCutsDisabled == disable)   return;
        this.shortCutsDisabled = disable;
        this.oe.sharedInterface.getUIControllerMediaCenter().setShortCutsDisabled(disable);
    }

    updateShortCutsDisabled()   {
        let disable = this.mounted && this.isOpen && this.oe.isReady();
        this.setShortCutsDisabled(disable);
    }

    saveIfNeeded(id)  {
        if(!this.needsSave)   return;
        this.needsSave = false;

        id = id || this.id;
        
        if(!this.oe.isReady() || typeof(id) !== 'number')   return;

        let viewerEditParams = this.oe.sharedInterface.getUIControllerNote().getNoteViewerEditParams(id);
        if(!(viewerEditParams.flags & OENoteViewerEditFlags.autosave))    return;

        let stateUID = this.oe.sharedInterface.getUIControllerNote().getNoteStateUID(id);

        this.oe.sharedInterface.getUIControllerNote().setInActivePresentationSlide(OENoteStateBits.text, stateUID);
    }

    updateIsOpenState()   {
        if(this.isOpen && !this.canOpen())	{
            this.close();
        }
    }

    updateSingleLineState() {
        if(this.id === null)    return;
        let viewerEditParams = this.oe.sharedInterface.getUIControllerNote().getNoteViewerEditParams(this.id);
        let singleLine = !!(viewerEditParams.flags & OENoteViewerEditFlags.singleLine);
        this.setState({singleLine: singleLine});
    }

    updateMaxTextLengthState() {
        if(this.id === null)    return;
        let viewerEditParams = this.oe.sharedInterface.getUIControllerNote().getNoteViewerEditParams(this.id);
        this.setState({maxTextLength: viewerEditParams.maxTextLength});
    }

    updateState(released)   {
        retardUpdate(this, () => {
            if(!this.oe.isReady() || released === true)   {
                this.setId(null);
                this.close();
                this.updateShortCutsDisabled();
                return;
            }

            this.updateIsOpenState();
            this.updateSingleLineState();
            this.updateMaxTextLengthState();
            this.updateShortCutsDisabled();
        });
    }

    onOpenEvent(id) {
        if(!this.canOpen(id))  {
            this.close();
            return;
        }
        this.setId(id);
        this.open();
    }

    /*
    onNoteLongTouched(message, userInfo) {
        this.onOpenEvent(userInfo.ID);
    }
    */

    onNoteClicked(message, userInfo)    {
        this.onOpenEvent(userInfo.ID);
    }

    onNotesEnabledChanged(message, userInfo) {
        this.updateIsOpenState();
    }

    onNotesEditModeChanged(message, userInfo) {
        this.updateIsOpenState();
    }

    onNoteFlagsChanged(message, userInfo) {
        if(userInfo.ID !== this.id) return;
        this.updateIsOpenState();
    }

    onNoteViewerEditParamsChanged(message, userInfo) {
        if(userInfo.ID !== this.id) return;
        retardUpdate(this, () => {
            this.updateSingleLineState();
            this.updateMaxTextLengthState();
        });
    }

    onNoteRemoved(message, userInfo) {
        if(userInfo.ID !== this.id) return;
        this.close();
    }

    onPresentationAnimationModeChanged(message, userInfo) {
        if(this.oe.sharedInterface.getUIControllerPresentation().getAnimationMode() == this.oe.Module.AnimationMode.play)   {
            this.close();
        }
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.note) {
            this.updateIsOpenState();
        }
    }

    render() {

        const scrollbar = {
            bare:                           true,
            horizontalTrackVisiblity:       this.state.singleLine ? CustomScrollbarTrackVisibility.auto : CustomScrollbarTrackVisibility.none,
            verticalTrackVisiblity:         this.state.singleLine ? CustomScrollbarTrackVisibility.none : CustomScrollbarTrackVisibility.always,
        };

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OENotePopover
                    moduleId={this.props.moduleId}
                    className="popover-control viewer-edit-popover"
                    boundariesElement={this.props.boundariesElement}
                    placement="bottom"
                    noHeader={true}
                    buttonClassName="transparent-btn"
                    headerSeparator={false}
                    isOpen={this.state.isOpen && this.state.rect !== null}
                    onToggle={this.onToggle}
                    contentClassName="note-viewer-edit-popover"
                    id={this.state.id}
                >

                    <OENoteTextEdit
                        moduleId={this.props.moduleId}
                        singleLine={this.state.singleLine}
                        autofocus={true}
                        scrollToEnd={true}
                        maxTextLength={this.state.maxTextLength}
                        scrollbar={scrollbar}
                        force={true}
                        id={this.state.id}
                        onChange={this.onChange}
                        onKeyDown={this.onKeyDown}
                    />

                </OENotePopover>
            </React.Fragment>
        );
    }
    
    onToggle()  {
        this.close();
    }

    onChange(sender, value) {
        this.needsSave = true;
    }

    onKeyDown(sender, e)    {
        if(this.state.singleLine && e.key === 'Enter')  {
            this.close();
        }
    }
}

OENoteViewerEditPopover.defaultProps = {
    moduleId:               '',
};

OENoteViewerEditPopover.propTypes = {
    moduleId:               PropTypes.string,
};